import { useQueryClient } from '@tanstack/vue-query';

import { type Profile, profileKeys } from '@/entities/profile';
import { IS_BILLING_ENABLED } from '@/shared/config';

export function onboardingGuard() {
  const queryClient = useQueryClient();

  const profile = queryClient.getQueryData<Profile>(profileKeys.profile());

  const isUserVerified = IS_BILLING_ENABLED ? profile?.is_verified : true;
  const isUserSettled = profile?.is_email_confirmed && isUserVerified;
  const isUserMember = profile?.is_member && profile.is_email_confirmed;
  const isUserOnboarded = isUserSettled || isUserMember;

  if (isUserOnboarded) {
    return {
      name: 'profile',
    };
  }
}
